import React, { useState, useEffect } from 'react';
import { Trophy, Crown, Medal, Users } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * ReferralLeaderboard — Top 10 referrers this month with crown/medal icons.
 */
const RANK_ICONS = {
  1: { icon: Crown, color: 'text-amber-500', bg: 'bg-amber-50' },
  2: { icon: Medal, color: 'text-gray-400', bg: 'bg-gray-50' },
  3: { icon: Medal, color: 'text-orange-400', bg: 'bg-orange-50' },
};

const ReferralLeaderboard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
    if (!token) return;
    fetch(`${API_URL}/api/engagement/v2/referral-leaderboard`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null).then(setData).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div className="rounded-xl border border-gray-200 bg-white" data-testid="referral-leaderboard">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Trophy size={16} className="text-purple-500" />
          <span className="text-sm font-bold text-gray-800">Referral Champions</span>
        </div>
        <span className="text-xs text-gray-400">{data.month}</span>
      </div>

      {/* My stats */}
      <div className="px-4 py-2 bg-purple-50 border-b border-purple-100 flex items-center justify-between">
        <span className="text-xs text-purple-700 font-medium">Your referrals: {data.my_referrals}</span>
        <span className="text-xs text-purple-600 font-bold">+{data.my_hearts_earned} Hearts</span>
      </div>

      {/* Leaderboard */}
      <div className="divide-y divide-gray-50">
        {data.leaderboard?.length === 0 && (
          <div className="p-4 text-center">
            <Users size={24} className="text-gray-300 mx-auto mb-2" />
            <p className="text-xs text-gray-400">No referrals this month yet. Be the first!</p>
          </div>
        )}
        {data.leaderboard?.map(entry => {
          const rankInfo = RANK_ICONS[entry.rank];
          const RankIcon = rankInfo?.icon || null;
          return (
            <div key={entry.rank} className="px-4 py-2.5 flex items-center gap-3">
              <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${rankInfo ? rankInfo.bg : 'bg-gray-50'}`}>
                {RankIcon ? <RankIcon size={14} className={rankInfo.color} /> : <span className="text-gray-500">{entry.rank}</span>}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800 truncate">{entry.name}</p>
              </div>
              <div className="text-right">
                <p className="text-xs font-bold text-gray-700">{entry.referrals} refs</p>
                <p className="text-[10px] text-gray-400">+{entry.hearts_earned} Hearts</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReferralLeaderboard;
